import dynamic from 'next/dynamic'

const AppWrapperNoSSR = dynamic(() => import('./app-wrapper'), {
  ssr: false,
  loading: () => null, // Optional loading component
})

export default AppWrapperNoSSR
